import HeatMapDashboard from "../dashboard/HeatMapDashboard";

export default function HeatMapPage() {
  return <HeatMapDashboard />;
}
